import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="row-link"
// Makes table rows clickable while still allowing action buttons and links to work.
export default class extends Controller {
  static values = {
    url: String
  }

  navigate(event) {
    if (event.type === "keydown" && !["Enter", " "].includes(event.key)) {
      return
    }

    if (event.target.closest("a, button, input, select, textarea")) {
      return
    }

    if (window.getSelection().toString()) {
      return
    }

    if (event.key === " ") {
      event.preventDefault()
    }

    if (this.hasUrlValue) {
      Turbo.visit(this.urlValue)
    }
  }
}
